module.exports = __webpack_public_path__ + "static/V521IR-e625e2c760b49b65a6ed323a36c9da0f.jpg";